import "./CampaignDetailsIO.css";
import { ReactComponent as Logo } from "../../../assests/amp_logo.svg";
import {
  Button,
  Col,
  Divider,
  Image,
  Input,
  message,
  Row,
  Spin,
  Table,
  Card,
  Modal,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import dayjs from "dayjs";
import { API_BASE_URL_IMAGE } from "../../../services/common";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveUserDetails } from "../../../store/thunks/common-thunks/commonThunk";
import { formatDate, formatToUSCurrency } from "../utils/Utils";
import { useMediaQuery } from "react-responsive";
import ProductRequestHoldModal from "../../modal/product-request-hold-modal/ProductRequestHoldModal";
import { Link } from "react-router-dom";
import { getBuyerCampaigns } from "../../../store/thunks/buyer-thunks/BuyerThunks";

const CampaignDetailsIO = ({
  campaignDetails,
  pdfLoader,
  isCheckoutPage,
  isIoSigning,
  isCustomTermsApplied,
  selectedRadio,
}) => {
  const dispatch = useDispatch();
  const { Text } = Typography;
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isCheckout = isCheckoutPage ?? false;
  const [buyerName, setBuyerName] = useState(campaignDetails?.buyer_by_name);
  const [ifToBuyer, setIfToBuyer] = useState(campaignDetails?.buyer_user_name);
  const isDocusignReview = sessionStorage.getItem("isDocusign");
  const [address, setAddress] = useState(campaignDetails?.buyer_user_address);
  const [attn, setAttn] = useState(campaignDetails?.buyer_user_attn);
  const [email, setEmail] = useState(campaignDetails?.buyer_user_email);
  const { isLoading: productsLoader } = useSelector((state) => state.products);
  const {
    buyerCampaignsList,
    isLoading: buyerCampaignsLoader,
    buyerSavedCampaignsLoader,
    getBuyerCampaignsLoading,
  } = useSelector((state) => state.buyerCampaigns);
  const isLoading = pdfLoader || productsLoader;
  const isLoggedIn = useSelector((state) => state?.login?.isAuthenticated);
  const PDF_BASE_URL = "/pdf";
  const formatSize = (value) => {
    return value
      .replace(" feet", "'") // Convert feet to '
      .replace(" Line Inches", '"') // Convert inches to "
      .replace(" pixels", " px"); // Convert pixels to px
  };
  const [isHoldRequestModalOpen, setIsHoldRequestModalOpen] = useState(false);
  const [productActionType, setProductActionType] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [holdStatus, setHoldStatus] = useState(0);
  const columns = [
    {
      title: "SI no.",
      dataIndex: "slno",
      align: "center",
      width: 50,
    },
    ...(isIoSigning == true
      ? [
        {
          title: "Action",
          dataIndex: "action",
          align: "center",
          width: 155,
          render: (_, record) => {
            const status = record?.product?.hold_approval_status;
            return (
              <Row
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <Button
                  type="primary"
                  onClick={() => handleRequestHold(record?.product)}
                  className={`billboard-buttons billboard-button-1 io-request-btn ${status == 0 ? "hold-status-in-progress" : status == 1 ? "hold-status-approved" : status == 2 ? "hold-status-rejected" : ""}`}
                >
                  {status == 0
                    ? "Hold Requested"
                    : status == 1
                      ? "Hold Approved"
                      : status == 2
                        ? "Hold Rejected"
                        : "Request Hold"}
                </Button>
                {status !== undefined && status !== null && status !== 1 && (
                  <Text
                    style={{
                      textDecoration: "underline",
                      color: "#007BFF",
                      cursor: "pointer",
                    }}
                    onClick={() => handleMoveProduct(record?.product)}
                  >
                    Move to Campaign
                  </Text>
                )}
              </Row>
            );
          },
        },
      ]
      : []),
    {
      title: "Product ID & Title",
      dataIndex: "productIdAndTitle",
      align: "left",
      width: 200,
      render: (text, record) => (
        <span
          onClick={() => handleProductDetails(record.product)}
          style={{
            cursor: "pointer",
            color: "#007bff",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      align: "left",
      width: 80,
    },
    {
      title: "Product Location",
      dataIndex: "billboardLoc",
      align: "left",
      width: 150,
    },
    {
      title: "Size",
      dataIndex: "size",
      align: "center",
      width: 120,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      align: "left",
      width: 100,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      align: "left",
      width: 100,
    },
    {
      title: "Days",
      dataIndex: "days",
      align: "center",
      width: 80,
    },
    {
      title: "Unit Price($)",
      dataIndex: "unitPrice",
      align: "right",
      width: 100,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "center",
      width: 80,
    },
    {
      title: "Product Price($)",
      dataIndex: "productPrice",
      align: "right",
      width: 150,
    },
    {
      title: "Tax Amount($)",
      dataIndex: "taxAmount",
      align: "right",
      width: 150,
      render: (text) => text,
    },
    {
      title: "Installation + Production Price ($)",
      dataIndex: "installationAndProductionPrice",
      align: "right",
      width: 220,
    },
    {
      title: "Net Total($)",
      dataIndex: "netTotal",
      align: "right",
      width: 150,
    },
  ];

  const dealInfoColumns = [
    {
      title: "Offer Type",
      dataIndex: "offerType",
    },
    {
      title: "Sender",
      dataIndex: "sender",
    },
    {
      title: "Comments",
      dataIndex: "comments",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];
  // Current Page (Table Click Function)
  const handleProductDetails = (product) => {
    if (isLoggedIn) {
      const productUrl = `/buyer/productsdetails?_id=${btoa(product?.product_id)}&title=${encodeURIComponent(product?.title)}`;
      window.open(productUrl, "_blank", "noopener,noreferrer");
    } else {
      const productUrl = `/productsdetails?_id=${btoa(product?.product_id)}`;
      window.open(productUrl);
    }
  };

  const data = campaignDetails?.products?.map((product, index) => ({
    product: product,
    slno: (index + 1).toString(),

    productIdAndTitle: `${product?.siteNo} ${product?.title}`,
    type: product?.type,
    billboardLoc: product?.city_name || "N/A",
    size:
      formatSize(product?.width) + " X " + formatSize(product?.height) || "N/A",
    startDate: dayjs(product?.booked_from).format("MM-DD-YYYY") || "N/A",
    endDate: dayjs(product?.booked_to).format("MM-DD-YYYY") || "N/A",
    days:
      product?.booked_from && product?.booked_to
        ? dayjs(product?.booked_to).diff(dayjs(product?.booked_from), "day") + 1
        : "N/A",
    unitPrice:
      formatToUSCurrency(parseFloat(product?.price || 0)?.toFixed(2)) || 0,
    quantity: product?.quantity || 0,
    productPrice:
      formatToUSCurrency(parseFloat(product?.price || 0)?.toFixed(2)) || 0,
    taxAmount: (
      <>
        ({product?.tax_percentage}%)
        <br />
        {(Number(product?.tax_percentage_amount) || 0).toFixed(2)}
      </>
    ),
    installationAndProductionPrice:
      `${formatToUSCurrency(
        (Number(product?.install_cost_price) || 0)?.toFixed(2),
      )} + ${formatToUSCurrency(
        (Number(product?.production_cost_price) || 0)?.toFixed(2),
      )} ` || 0,
    netTotal:
      product?.owner_price || 0
        ? `${formatToUSCurrency(
          (
            Number(
              product?.owner_price +
              product?.tax_percentage_amount +
              product?.install_production_cost || 0,
            ) || 0
          )?.toFixed(2),
        )}`
        : `${formatToUSCurrency(
          (
            Number(
              (product?.price || 0) * (product?.quantity || 1) +
              product?.tax_percentage_amount +
              product?.install_production_cost || 0,
            ) || 0
          )?.toFixed(2),
        )}`,
  }));
  const dealInfoData = (product) => {
    return product?.offer_comments?.map((product, index) => ({
      offerType: product?.offer_type,
      sender: product?.Sender,
      comments: product?.comment,
      status: product?.final_status || "N/A",
    }));
  };

  const SaveBuyerAddressDetails = () => {
    if (!ifToBuyer && !address && !attn && !email) {
      message.error("Please fill at least one field before saving.");
      return;
    }
    const payload = {
      buyer_by_name: buyerName,
      buyer_user_address: address,
      buyer_user_attn: attn,
      buyer_user_email: email,
      buyer_user_name: ifToBuyer,
      campaign_id: campaignDetails?.campaignId,
    };
    dispatch(saveUserDetails(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        setIfToBuyer("");
        setAddress("");
        setAttn("");
        setEmail("");
      }
    });
  };

  const handleRequestHold = (product) => {
    setProductActionType("hold_request");
    setSelectedProduct(product);
    setIsHoldRequestModalOpen(true);
  };
  const handleMoveProduct = (product) => {
    setProductActionType("move_to_campaign");
    setSelectedProduct(product);
    setIsHoldRequestModalOpen(true);
  };
  const handleCloseHoldModal = () => {
    setSelectedProduct(null);
    setIsHoldRequestModalOpen(false);
  };
  const todayDate = formatDate(new Date());
  const mobileIO = (
    <div className="io-header-row">
      <Row>
        <Col span={isMobile ? 24 : 8}>
          <Logo className="io-logo-css" />
        </Col>
        <Col span={isMobile ? 12 : 8} className="io-campaign-details-row-text">
          Insertion Order
        </Col>
        <Col span={isMobile ? 12 : 8} className="io-campaign-details-row-text">
          {" "}
          Date : {todayDate}{" "}
        </Col>
      </Row>
      <div className="default-color small-font">
        {" "}
        Campaign Name : {campaignDetails?.name}
      </div>
      <div
        className={`io-table-container ${isDocusignReview ? "set-scroll-table" : ""}`}
      >
        <Table
          columns={columns}
          dataSource={data}
          className="view-io-table"
          tableLayout="fixed"
          pagination={false}
        />
      </div>
      <div >
        <div className="terms-header">Payment Terms:</div>
        <span className="terms-text">
          {`${campaignDetails?.percentagevalue?.toFixed(2)}% Due upon purchase`}
        </span>
        <div className="terms-text">
          ${(100 - campaignDetails?.percentagevalue)?.toFixed(2)}% Due upon
          invoice
        </div>
        <Row className="terms-row">
          <Col span={12} className="terms-label">
            Tax:
          </Col>
          <Col span={12} align="end">
            {formatToUSCurrency(
              Number(campaignDetails?.tax_percentage_amount_sum)?.toFixed(2),
            )}
          </Col>

          <Divider className="zero-padding" />
          <Col span={12} className="terms-label">
            Installation + Production:
          </Col>
          <Col span={12} align="end">
            {formatToUSCurrency(
              parseFloat(campaignDetails?.install_production_cost_sum)?.toFixed(
                2,
              ),
            )}
          </Col>
          <Divider className="zero-padding" />

          <Col span={12} className="terms-label">
            Subtotal:
          </Col>
          <Col span={12} align="end">
            {formatToUSCurrency(
              Number(
                campaignDetails?.totalamount -
                campaignDetails?.gross_fee_price -
                campaignDetails?.tax_percentage_amount_sum -
                campaignDetails?.install_production_cost_sum,
              )?.toFixed(2),
            )}
          </Col>

          <Divider className="zero-padding" />

          <Col span={12} className="terms-label">
            {" "}
            {`Gross fee (${campaignDetails?.gross_fee_percentage
              ? campaignDetails?.gross_fee_percentage
              : ""
              } %):`}
          </Col>
          <Col span={12} align="end">
            {formatToUSCurrency(
              Number(campaignDetails?.gross_fee_price).toFixed(2),
            )}
          </Col>
          <Divider className="zero-padding" color="#000" />
          <Col span={12} className="terms-label">
            Grand Total:
          </Col>
          <Col span={12} align="end">
            {" "}
          </Col>
        </Row>
      </div>
    </div>
  );

  // get if the fields are readonly
  const isReadonly = isCheckout || campaignDetails?.status != 100;
  return (
    <>
      <div className="view-io-main-content-div">
        {!isMobile ? (
          <>
            <Row className="io-container-sub-div">
              <Col>
                <Logo className="io-logo-css" />
              </Col>
            </Row>
            <Col>
              <div className="io-col-sub-div">
                <span
                  className="io-campaign-details-row-text"
                  style={{
                    textAlign: "center",
                  }}
                >
                  INSERTION ORDER (IO)
                </span>
              </div>
            </Col>
            <Row className="io-campaign-details-row">
              <Col>
                <div className="io-col-sub-div">
                  <span
                    className="io-campaign-details-row-text"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    Campaign Details
                  </span>
                  <span className="view-io-text view-io-left-alignment">
                    {`Campaign Name: ${campaignDetails?.name}`}
                  </span>
                  <span className="view-io-text view-io-left-alignment">
                    Start Date: {campaignDetails?.startDate || "-"}
                  </span>
                  <span className="view-io-text view-io-left-alignment">
                    End Date: {campaignDetails?.endDate || "-"}
                  </span>
                </div>
              </Col>
              <Col>
                <div className="io-col-sub-div">
                  <span
                    className="io-campaign-details-row-text"
                    style={{
                      textAlign: "end",
                    }}
                  >
                    <br></br>
                  </span>
                  <div className="view-io-text view-io-left-alignment">
                    Date: {formatDate(dayjs())}
                  </div>
                  <span className="view-io-text view-io-left-alignment">
                    {`IO Number: ${campaignDetails?.id}`}
                  </span>
                </div>
              </Col>
            </Row>

            <Col style={{ marginTop: "2.7rem" }}>
              <span
                className="io-campaign-details-row-text"
                style={{
                  textAlign: "end",
                }}
              >
                Selected Products & Pricing
              </span>
            </Col>
            <Col style={{ marginTop: "1rem" }}>
              <div
                className={`io-table-container ${isDocusignReview ? "set-scroll-table" : ""}`}
              >
                <Table
                  columns={columns}
                  dataSource={data}
                  className="view-io-table"
                  tableLayout="fixed"
                  pagination={false}
                />
              </div>
            </Col>
            <Row className="io-terms-row">
              <Col style={{ padding: "1rem" }}>
                <div className="sprice-section-first-div">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Payment Terms:
                  </span>
                  {
                    campaignDetails?.campaign_terms_array?.length > 0 && (
                      <table className="payment-terms-table">
                        <tbody>
                          {campaignDetails?.campaign_terms_array?.map((term, index) => {
                            // const matchedProduct = campaignDetails?.products?.find(
                            //   (product) => product?.id === term?.product_booking_id
                            // );

                            return (
                              <tr key={term?._id || index}>
                                <td>
                                  <div style={{ display: 'flex' }}>{term?.due_date}</div>

                                  {/* {matchedProduct && (
                                    <>
                                      <div style={{ display: 'flex', textAlign: 'justify' }}>{matchedProduct?.title}</div>
                                      <div style={{ display: 'flex', textAlign: 'justify' }}>{matchedProduct?.siteNo}</div>
                                    </>
                                  )} */}
                                </td>

                                <td>
                                  {term?.payment_percentage}%
                                </td>

                                <td>
                                  $
                                  {Number(term?.payment_amount || 0)}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )
                  }
                </div>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Art due date:{" "}
                  </span>
                  <span className="view-io-text">See Product details</span>
                </div>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Restrictions:{" "}
                  </span>
                  <span className="view-io-text">See Product details</span>
                </div>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Cancellation:{" "}
                  </span>
                  <span className="view-io-text">See Product details</span>
                </div>
              </Col>
              <Col style={{ padding: "1rem" }}>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Tax:
                  </span>
                  <span className="view-io-text">
                    {formatToUSCurrency(
                      Number(
                        campaignDetails?.tax_percentage_amount_sum,
                      )?.toFixed(2),
                    )}
                  </span>
                </div>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Installation + Production:{" "}
                  </span>
                  <span className="view-io-text">
                    {formatToUSCurrency(
                      parseFloat(
                        campaignDetails?.install_production_cost_sum,
                      )?.toFixed(2),
                    )}
                  </span>
                </div>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Total:{" "}
                  </span>

                  <span className="view-io-text">
                    {formatToUSCurrency(
                      Number(
                        campaignDetails?.totalamount -
                        campaignDetails?.gross_fee_price -
                        campaignDetails?.tax_percentage_amount_sum -
                        campaignDetails?.install_production_cost_sum,
                      )?.toFixed(2),
                    )}
                  </span>
                </div>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    {`Gross fee (${campaignDetails?.gross_fee_percentage
                      ? campaignDetails?.gross_fee_percentage
                      : ""
                      } %):`}
                  </span>
                  <span className="view-io-text">
                    {formatToUSCurrency(
                      Number(campaignDetails?.gross_fee_price).toFixed(2),
                    )}
                  </span>
                </div>
                <div className="price-section">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Grand Total:{" "}
                  </span>
                  <span className="view-io-text">
                    {`${formatToUSCurrency(
                      Number(campaignDetails?.totalamount) +
                      Number(campaignDetails?.newprocessingfeeamtSum),
                    )}`}
                  </span>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <>{mobileIO}</>
        )}

        <div className="io-address-div">
          <div style={{ padding: "1rem" }}>
            <div className="view-io-text">
              1.Addresses. All notices, correspondence and invoices shall be
              sent to the addresses below.
            </div>
            <Row style={{ justifyContent: "space-between" }}>
              <Col style={{ padding: "0.5rem" }}>
                <div className="io-common-div-css">
                  <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                    If to buyer:{" "}
                  </span>
                  <Input
                    readOnly={isReadonly}
                    className="view-io-signature"
                    placeholder={isReadonly ? "" : "Enter text here"}
                    value={ifToBuyer}
                    onChange={(e) => {
                      setIfToBuyer(e.target.value);
                    }}
                  />
                </div>
                <div className="io-common-div-css">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Address:{" "}
                  </span>
                  <Input
                    readOnly={isReadonly}
                    className="view-io-signature"
                    placeholder={isReadonly ? "" : "Enter address here"}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
                <div className="io-common-div-css">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Attn:{" "}
                  </span>
                  <Input
                    readOnly={isReadonly}
                    className="view-io-signature"
                    placeholder={isReadonly ? "" : "Enter name here"}
                    value={attn}
                    onChange={(e) => setAttn(e.target.value)}
                  />
                </div>
                <div className="io-common-div-css">
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Email:{" "}
                  </span>
                  <Input
                    readOnly={isReadonly}
                    className="view-io-signature"
                    placeholder={isReadonly ? "" : "Enter email here"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </Col>
              {/* <Col style={{ padding: "0.5rem" }}>
                <div>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    If to AMP:{" "}
                  </span>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Advertising Marketplace, LLC
                  </span>
                </div>
                <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                  28832 Via Buena Vista
                </span>
                <br />
                <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                  San Juan Cap, CA 92675
                </span>
                <div className="view-io-terms view-io-terms-header view-io-left-alignment">
                  Richard McClemmy
                </div>
                <div className="view-io-terms view-io-terms-header view-io-left-alignment">
                  mcclemmy.richard@gmail.com
                </div>
              </Col> */}
            </Row>
            {!isCheckout && campaignDetails?.status == 100 && (
              <Button
                style={{
                  margin: "0.5rem",
                }}
                className="io-save-button-css billboard-button-2"
                onClick={SaveBuyerAddressDetails}
              >
                Save
              </Button>
            )}
            <div className="view-io-text">
              2. Standard Terms and Conditions{" "}
              <a
                href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="styling-hover-link"
                style={{ color: "#007bff" }}
              >
                (“Standard Terms”)
              </a>{" "}
              are incorporated as part of this Agreement, and buyer acknowledges
              that buyer has reviewed the{" "}
              <a
                href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="styling-hover-link"
                style={{ color: "#007bff" }}
              >
                Standard Terms
              </a>{" "}
              and agrees to be bound by the provisions thereof. Should the{" "}
              <a
                href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="styling-hover-link"
                style={{ color: "#007bff" }}
              >
                Standard Terms
              </a>{" "}
              conflict with the Main Agreement above then the Insertion Order
              shall govern
            </div>
            <br />
            <div className="view-io-text">
              3. This Agreement, once executed is not cancelable except by
              expiration or termination pursuant to the{" "}
              <a
                href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="styling-hover-link"
                style={{ color: "#007bff" }}
              >
                Standard Terms{" "}
              </a>
              and Conditions. IN WITNESS WHEREOF, the parties, through their
              representatives, have executed this Agreement.
            </div>
            <Row>
              <Col style={{ padding: "0.5rem" }} span={isMobile ? 20 : 6}>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                    Buyer
                  </span>
                </div>
                <div
                  style={{ padding: "0.5rem" }}
                  className="view-io-terms-input-div"
                >
                  {campaignDetails?.status > 100 ? (
                    <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                      By:
                      {campaignDetails?.buyer_signature_path ? (
                        <Image
                          preview={false}
                          src={`${API_BASE_URL_IMAGE}/uploads/images/docusign_signatures/${campaignDetails?.buyer_signature_path}`}
                          width={200}
                          height={100}
                        />
                      ) : (
                        <></>
                      )}
                    </span>
                  ) : (
                    <>
                      <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                        By:{" "}
                      </span>
                      <span className="view-io-text">
                        {" "}
                        Buyer Signing Authority
                      </span>
                    </>
                  )}
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Date:{" "}
                  </span>
                  <span className="view-io-text">
                    {dayjs().format("MM-DD-YYYY")}
                  </span>
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Its:{" "}
                  </span>
                  <span className="view-io-text"></span>
                </div>
              </Col>
              <Col style={{ padding: "0.5rem" }} span={isMobile ? 20 : 6}>
                {/*  <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                    AMP
                  </span>
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    By:{" "}
                  </span>
                  <span className="view-io-text">Richard McClemmy</span>
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Date:{" "}
                  </span>
                  <span className="view-io-text">
                    {" "}
                    {dayjs().format("MM-DD-YYYY")}
                  </span>
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Its:{" "}
                  </span>
                  <span className="view-io-text"></span>
                </div> */}
              </Col>
              <Col style={{ padding: "0.5rem" }}>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                    Seller
                  </span>
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    By:{" "}
                  </span>
                  {campaignDetails?.products?.length > 0 &&
                    campaignDetails.products.map((product, index) =>
                      product?.seller_signature_path ? (
                        <Image
                          key={product?.id || index}
                          preview={false}
                          src={`${API_BASE_URL_IMAGE}/uploads/images/docusign_signatures/${product.seller_signature_path}`}
                          width={100}
                          height={100}
                        />
                      ) : <span className="view-io-text"> Per User Agreement</span>

                    )}
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Date:{" "}
                  </span>
                  <span className="view-io-text">
                    {" "}
                    {dayjs().format("MM-DD-YYYY")}
                  </span>
                </div>
                <div style={{ padding: "0.5rem" }}>
                  <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                    Its:{" "}
                  </span>
                  <span className="view-io-text"></span>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        {campaignDetails?.products_in_campaign?.map((product, index) => {
          const productOfferComment = campaignDetails?.products?.find(
            (item) => item?.siteNo === product?.siteNo,
          );
          return (
            <>
              {index === 0 && <Divider className="io-divider-css"></Divider>}
              <Row>
                <Col style={{ width: isMobile ? "100%" : "50%" }}>
                  <p className="io-product-details-title">Product Details</p>
                  <div
                    className="common-css"
                    style={{ flexDirection: "column" }}
                  >
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        AMP Product :
                      </span>
                      <span
                        className="styling-hover-link"
                        onClick={() =>
                          handleProductDetails(
                            campaignDetails?.products?.find(
                              (item) => item?.siteNo === product?.siteNo,
                            ),
                          )
                        }
                      >
                        {" "}
                        {product?.siteNo}
                      </span>
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Type :
                      </span>

                      {product?.type}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Title :
                      </span>
                      <span
                        className="styling-hover-link"
                        onClick={() =>
                          handleProductDetails(
                            campaignDetails?.products?.find(
                              (item) => item?.title === product?.title,
                            ),
                          )
                        }
                      >
                        {product?.title}
                      </span>
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Description :
                      </span>
                      {product?.description}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Address 1 :
                      </span>
                      {product?.address}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Address 2 :
                      </span>
                      {`${product?.city}, ${product?.state}, ${product?.zipcode}`}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Country :
                      </span>
                      {product?.country_name}
                    </div>
                    {product?.locationDesc !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Location Description :
                        </span>
                        {product?.locationDesc}
                      </div>
                    )}

                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Unit Quantity :
                      </span>
                      {product?.unitQty}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Height :
                      </span>
                      {product?.height}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Width :
                      </span>
                      {product?.width}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Panel Size :
                      </span>
                      {product?.panelSize}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Available 4-week Periods :
                      </span>
                      {Number(product?.weekPeriod)?.toFixed(2)}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Rate Card (4 weeks) :
                      </span>
                      {formatToUSCurrency(
                        Number(product?.rateCard)?.toFixed(2),
                      )}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Fixed/Variable :
                      </span>
                      {product?.fix}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Minimum Days :
                      </span>
                      {product?.minimumdays}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Installation Cost :
                      </span>
                      {formatToUSCurrency(
                        Number(product?.installCost)?.toFixed(2),
                      )}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Production Cost :
                      </span>
                      {formatToUSCurrency(
                        Number(product?.productioncost)?.toFixed(2),
                      )}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Product Direction :
                      </span>
                      {product?.imgdirection}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Illumination :
                      </span>
                      {product?.lighting}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Facing :
                      </span>
                      {product?.direction}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Latitude :
                      </span>
                      {product?.lat}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Longitude :
                      </span>
                      {product?.lng}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Restrictions :
                      </span>
                      {product?.notes}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Cancellation Policy :
                      </span>
                      {product?.cancellation_policy}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Payment Terms :
                      </span>
                      {product?.cancellation_terms}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Median HHI :
                      </span>
                      {product?.mediahhi !== "NaN" && product?.mediahhi}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Impression 18 - 49 :
                      </span>
                      {product?.firstImpression !== "NaN" &&
                        product?.firstImpression}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        CPM Adults 18 - 49 :
                      </span>
                      {product?.firstcpm !== "NaN" &&
                        formatToUSCurrency(
                          Number(product?.firstcpm)?.toFixed(2),
                        )}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Impression 18 - Plus :
                      </span>
                      {product?.secondImpression !== "NaN" &&
                        product?.secondImpression}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        CPM Adults 18 - Plus :
                      </span>

                      {product?.cpm !== "NaN" &&
                        formatToUSCurrency(Number(product?.cpm)?.toFixed(2))}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Impression 25 - 54 :
                      </span>
                      {product?.thirdImpression !== "NaN" &&
                        product?.thirdImpression}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        CPM Adults 25 - 54 :
                      </span>
                      {product?.thirdcpm !== "NaN" &&
                        formatToUSCurrency(
                          Number(product?.thirdcpm)?.toFixed(2),
                        )}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Impression (HA25 - HA54) :
                      </span>
                      {product?.forthImpression !== "NaN" &&
                        product?.forthImpression}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        CPM Hispanic 25 - 54 :
                      </span>
                      {product?.forthcpm !== "NaN" &&
                        formatToUSCurrency(
                          Number(product?.forthcpm)?.toFixed(2),
                        )}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Audited :
                      </span>
                      {product?.audited}
                    </div>
                    <div style={{ fontFamily: "Roboto" }}>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Seller Id :
                      </span>
                      {product?.sellerId}
                    </div>
                    {product?.Comments !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Comments :
                        </span>
                        {product?.Comments}
                      </div>
                    )}
                    {(product?.billingYes !== "" ||
                      product?.billingNo !== "") && (
                        <div style={{ fontFamily: "Roboto" }}>
                          <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                            AMP Bills :
                          </span>
                          {product?.billingYes
                            ? product?.billingYes
                            : product?.billingNo}{" "}
                          {product?.offer_comments_data}
                        </div>
                      )}
                    {(product?.servicingNo !== "" ||
                      product?.servicingYes !== "") && (
                        <div style={{ fontFamily: "Roboto" }}>
                          <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                            AMP Services :
                          </span>
                          {product?.servicingNo
                            ? product?.servicingNo
                            : product?.servicingYes}
                          {product?.offer_comments_data}
                        </div>
                      )}
                    {product?.spotLength !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Spot Length :
                        </span>
                        {product?.spotLength}
                      </div>
                    )}
                    {product?.ageloopLength !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Loop Length :
                        </span>
                        {product?.ageloopLength}
                      </div>
                    )}
                    {product?.fliplength !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Flip Length :
                        </span>
                        {product?.fliplength}
                      </div>
                    )}
                    {product?.medium !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Medium :
                        </span>
                        {product?.medium}
                      </div>
                    )}
                    {product?.product_newAge !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Product :
                        </span>
                        {product?.product_newAge}
                      </div>
                    )}
                    {product?.file_type !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          File Type :
                        </span>
                        {product?.file_type}
                      </div>
                    )}
                    {product?.staticMotion !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Static Motion :
                        </span>
                        {product?.staticMotion}
                      </div>
                    )}
                    {product?.sound !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Sound :
                        </span>
                        {product?.sound}
                      </div>
                    )}
                    {product?.network !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Network :
                        </span>
                        {product?.network}
                      </div>
                    )}
                    {product?.nationloc !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          National Local :
                        </span>
                        {product?.nationloc}
                      </div>
                    )}
                    {product?.daypart !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Day Part :
                        </span>
                        {product?.daypart}
                      </div>
                    )}
                    {product?.genre !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Genre :
                        </span>
                        {product?.genre}
                      </div>
                    )}
                    {product?.costperpoint !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Cost Per Point :
                        </span>
                        {formatToUSCurrency(
                          Number(product?.costperpoint)?.toFixed(2),
                        )}
                      </div>
                    )}
                    {product?.placement !== "" && (
                      <div style={{ fontFamily: "Roboto" }}>
                        <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                          Ad Type :
                        </span>
                        {product?.placement}
                      </div>
                    )}
                  </div>
                </Col>
                <Col className="io-image-display-col">
                  <Image
                    preview={false}
                    src={`${API_BASE_URL_IMAGE}${product?.image[0]}`}
                  ></Image>
                  <Image
                    preview={false}
                    src={
                      product?.map_image
                        ? `${API_BASE_URL_IMAGE}${product?.map_image[0]}`
                        : ""
                    }
                  ></Image>
                </Col>
              </Row>
              {(productOfferComment?.offer_individual_comments?.length > 0 ||
                productOfferComment?.offer_comments?.length > 0) && (
                  <div
                    style={{
                      paddingTop: "1rem",
                    }}
                  >
                    <span
                      className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment"
                      style={{ color: "#007bff" }}
                    >
                      Deal Information:
                    </span>
                  </div>
                )}

              <Col style={{ marginTop: "0.5rem" }}>
                {productOfferComment?.offer_individual_comments?.length > 0 && (
                  <table className="view-io-table">
                    <tbody>
                      <tr>
                        <td className="io-comments-css">
                          {
                            productOfferComment?.offer_individual_comments?.[0]
                              ?.product_comments
                          }
                        </td>
                        <td className="io-comments-css">
                          {
                            productOfferComment?.offer_individual_comments?.[1]
                              ?.product_comments
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {/*

                Future use case 

                 {product?.offer_comments?.length > 0 && (
                  <Table
                    columns={dealInfoColumns}
                    dataSource={dealInfoData(product)}
                    className="view-io-table"
                    pagination={false}
                  />
                )} */}
              </Col>
              <Row className="io-billing-css">
                {product?.billingNo !== "" ? (
                  <Col>
                    <div className="io-billing-text-css">
                      <span
                        className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment"
                        style={{ color: "#007bff" }}
                      >
                        Billing:
                      </span>
                    </div>
                    <div>
                      <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                        {product?.company_name}
                        {/* {product?.email === "mridulkashyap57@gmail.com"
                          ? "Richard Mcclemmy"
                          : product?.sub_seller_yes_no === 1
                          ? product?.sub_seller_name
                          : product?.sub_seller_yes_no === 0
                          ? product?.company_name
                          : product?.sub_seller_yes_no !== 0 &&
                            product?.sub_seller_yes_no !== 1
                          ? "Richard Mcclemmy"
                          : "Richard Mcclemmy"} */}
                      </span>
                    </div>
                    <div>
                      <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                        Email:{" "}
                      </span>
                      <span>
                        {/* { product?.email} */}
                        {product?.email === "mridulkashyap57@gmail.com"
                          ? "mcclemmy.richard@gmail.com"
                          : product?.sub_seller_yes_no === 1
                            ? product?.sub_seller_email
                            : product?.sub_seller_yes_no === 0
                              ? product?.email
                              : product?.sub_seller_yes_no !== 0 &&
                                product?.sub_seller_yes_no !== 1
                                ? "mcclemmy.richard@gmail.com"
                                : "mcclemmy.richard@gmail.com"}
                      </span>
                    </div>
                    <div>
                      <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                        Phone:{" "}
                      </span>
                      <span>
                        {/* {product?.phone} */}
                        {product?.email === "mridulkashyap57@gmail.com"
                          ? "+(714)293-3883"
                          : product?.sub_seller_yes_no === 1
                            ? product?.sub_seller_phone
                            : product?.sub_seller_yes_no === 0
                              ? product?.phone
                              : product?.sub_seller_yes_no !== 0 &&
                                product?.sub_seller_yes_no !== 1
                                ? "+(714)293-3883"
                                : "+(714)293-3883"}
                      </span>
                    </div>
                  </Col>
                ) : (
                  product?.billingYes !== "" && (
                    <Col>
                      <div className="io-billing-text-css">
                        <span
                          className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment"
                          style={{ color: "#007bff" }}
                        >
                          Billing:
                        </span>
                      </div>
                      <div>
                        <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                          {product?.company_name}
                        </span>
                      </div>
                      <div>
                        <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                          Email:{" "}
                        </span>
                        <span style={{ fontFamily: "Roboto" }}>
                          {product?.email}
                        </span>
                      </div>
                      <div>
                        <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                          Phone:{" "}
                        </span>
                        <span>{product?.phone}</span>
                      </div>
                    </Col>
                  )
                )}

                {product?.servicingNo !== "" ? (
                  <Col>
                    <div className="io-billing-text-css">
                      <span
                        className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment"
                        style={{ color: "#007bff" }}
                      >
                        Servicing:
                      </span>
                    </div>
                    <div>
                      <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                        {/* {product?.company_name} */}
                        {product?.email === "mridulkashyap57@gmail.com"
                          ? "Richard Mcclemmy"
                          : product?.sub_seller_yes_no === 1
                            ? product?.sub_seller_name
                            : product?.sub_seller_yes_no === 0
                              ? product?.company_name
                              : product?.sub_seller_yes_no !== 0 &&
                                product?.sub_seller_yes_no !== 1
                                ? "Richard Mcclemmy"
                                : "Richard Mcclemmy"}
                      </span>
                    </div>
                    <div>
                      <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                        Email:{" "}
                      </span>
                      <span style={{ fontFamily: "Roboto" }}>
                        {/* {product?.email} */}
                        {product?.email === "mridulkashyap57@gmail.com"
                          ? "mcclemmy.richard@gmail.com"
                          : product?.sub_seller_yes_no === 1
                            ? product?.sub_seller_email
                            : product?.sub_seller_yes_no === 0
                              ? product?.email
                              : product?.sub_seller_yes_no !== 0 &&
                                product?.sub_seller_yes_no !== 1
                                ? "mcclemmy.richard@gmail.com"
                                : "mcclemmy.richard@gmail.com"}
                      </span>
                    </div>
                  </Col>
                ) : (
                  product?.servicingYes !== "" && (
                    <Col>
                      <div className="io-billing-text-css">
                        <span
                          className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment"
                          style={{ color: "#007bff" }}
                        >
                          Servicing:
                        </span>
                      </div>
                      <div>
                        <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                          {product?.company_name}
                          {/* {"Richard Mcclemmy"} */}
                        </span>
                      </div>
                      <div>
                        <span className="view-io-terms view-io-terms-header view-io-left-alignment">
                          Email:{" "}
                        </span>
                        <span style={{ fontFamily: "Roboto" }}>
                          {product?.email}
                          {/* {"mcclemmy.richard@gmail.com"} */}
                        </span>
                      </div>
                    </Col>
                  )
                )}
              </Row>
              <Col>
                <div
                  className="io-footer-text"
                  style={{
                    color: "var(--Colors-Primary-500, #d2042d)",
                  }}
                >
                  Advertising Marketplace, LLC
                </div>
                <span className="io-footer-text">All Rights Reserved</span>
              </Col>
              <Divider className="io-divider-css"></Divider>
              {product?.sponsor_yes_no === "1" && (
                <Col>
                  <p className="io-sponser-text-css">
                    SPONSORSHIP{" "}
                    <a
                      href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      STANDARD TERMS AND CONDITIONS
                    </a>
                  </p>
                  <span style={{ fontFamily: "Roboto" }}>
                    The following sets forth the{" "}
                    <a
                      href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="styling-hover-link"
                      style={{ color: "#007bff" }}
                    >
                      Standard Terms{" "}
                    </a>
                    and Conditions to the Sponsorship Agreement (the “Main
                    Agreement”) between AMP, Buyer and Seller. Capitalized terms
                    used herein not otherwise defined shall have the same
                    meaning as the Main Agreement. The Insertion Order, its{" "}
                    <a
                      href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="styling-hover-link"
                      style={{ color: "#007bff" }}
                    >
                      Standard Terms{" "}
                    </a>
                    and Conditions and these Sponsorship{" "}
                    <a
                      href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="styling-hover-link"
                      style={{ color: "#007bff" }}
                    >
                      Standard Terms
                    </a>{" "}
                    and Conditions are collectively referred to as the
                    “Agreement.”
                  </span>
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    A. Sponsorship Fee. The Sponsorship Fee shall be payable in
                    full within thirty (30) days of receipt of an invoice. In
                    the event that some or all of the Sponsorship Fee is payable
                    by an agent or affiliate of Sponsor, Sponsor shall remain
                    responsible for ensuring timely payment of the Sponsorship
                    Fee to AMP and in the event that Sponsor’s agent or
                    affiliate fails to timely pay its applicable portion of the
                    Sponsorship Fee, AMP, in addition to its legal rights and
                    remedies, shall require full payment from Sponsor and
                    Sponsor’s failure to make full payment shall be deemed a
                    breach of this Agreement. Any and all production costs are
                    to be paid for by Sponsor under separate invoice. Upon
                    request of Sponsor, affidavits of performance will be
                    furnished by AMP but the furnishing of such affidavits shall
                    not serve as a condition precedent to the payment, or the
                    time of payment, of any bill rendered hereunder. Upon
                    acceptance of this Agreement AMP will reserve all applicable
                    elements identified above. Any non-use of any reserved
                    element by Sponsor will not waive any portion of Sponsor’s
                    liability.
                  </span>
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    B. Non-Exclusive Rights. No rights of exclusivity are
                    granted to Sponsor by this Agreement, except those that are
                    detailed in the main agreement, and nothing herein shall
                    limit in any manner AMP’s right to sell Sponsorship,
                    marketing or promotional rights for any product or service,
                    whether or not competitive with Sponsor.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    C. Sub-Brokering. Sponsor must obtain AMP’s written
                    authorization prior to sub-brokering any Sponsorship
                    Elements and AMP may withhold or deny authorization in its
                    sole discretion
                  </span>
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    D. Protection of Commercial Relationships. Sponsor
                    acknowledges that, insofar as AMP and Sponsor maintains a
                    variety of independent commercial relationships, AMP shall
                    have the unilateral right in its sole discretion to protect
                    those relationships and reject Sponsorship based on
                    product/service category exclusivity, the incompatibility or
                    competitive nature of the Sponsorship, the tenor and object
                    of the Sponsorship, or the promotion of a product or service
                    which does not constitute a Sponsor product or service.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    E.Promotional Rights of AMP. AMP may use Sponsor’s
                    Trademarks to promote its services with prior approval.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    {" "}
                    F. Trademarks. Except as provided in the Main Agreement, AMP
                    does not grant Sponsor any rights to use any Trademarks of
                    AMP and Sponsor does not grant AMP any rights to its
                    Trademarks.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    G. Indemnification by Sponsor. Sponsor shall defend,
                    indemnify and hold AMP, its Affiliates and the officers,
                    directors, partners, agents and employees of each, harmless
                    from and against any and all claims, suits, damages, losses,
                    liabilities, obligations, fines, penalties, costs and
                    expenses (whether based on tort, breach of contract, product
                    liability, patent or copyright or trademark infringement or
                    otherwise), including reasonable legal fees and expenses, of
                    whatever kind or nature (collectively, “Claims”), arising
                    out of or based on: (1) Sponsor’s breach or default under
                    this Agreement; (2) the use of Sponsor’s Trademarks; (3) any
                    Claims, including but not limited to Claims based on
                    defamation, invasion of privacy, infringement of copyright,
                    trademark or license, unfair or improper trade practices or
                    other wrongful business conduct, violation of Federal
                    Communication Commission rules and analogous state agencies,
                    by reason of the broadcast, telecast or publication of the
                    advertisements furnished by Sponsor; (4) any applicable
                    sales or other taxes due from or on behalf of Sponsor on any
                    sums paid by Sponsor (excluding only income taxes payable to
                    AMP on such sums) regardless of whether such taxes must be
                    collected by AMP on behalf of the taxing authority and
                    regardless of whether Sponsor shall challenge the assessment
                    or amount of such taxes; (5) the manner, use, sale or
                    offering of any of Sponsor service or product pursuant to a
                    consumer promotion approved by AMP hereunder; (6) liability
                    for any violation of law or regulation, or for any injury or
                    violation of the rights of any person resulting from
                    broadcasting of any material furnished by Sponsor, or the
                    use of any talent provided by Sponsor for the purposes of
                    the programs and announcements provided for herein; (7) any
                    negligent or willful act or omission or violation of any
                    contractual arrangement of Sponsor or its Affiliates, or the
                    officers, directors, partners, agents or employees of each,
                    in connection with its or their performance relating to this
                    Agreement; and/or (8) the content of the Sponsorship. The
                    provisions of this Paragraph G shall survive the expiration
                    or sooner termination of this Agreement.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    H. Indemnification by AMP. AMP shall defend, indemnify and
                    hold Sponsor, its Affiliates and the officers, directors,
                    partners, agents and employees of each, harmless from and
                    against any Claim arising out of or based on the sole
                    grossly negligent act or omission in violation of any
                    contractual arrangement of AMP or its Affiliates, or the
                    officers, directors, partners, agents or employees of each,
                    in connection with its or their performance relating to this
                    Agreement. The provisions of this Paragraph H shall survive
                    the expiration or sooner termination of this Agreement.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    I. Conditions on Indemnification. The party to whom
                    indemnification is owed (the “Indemnified Party”) shall give
                    notice to the party required to provide indemnification
                    under this Agreement (the “Indemnifying Party”) of any
                    action or proceeding for which indemnification is sought and
                    the Indemnifying Party (at its expense) shall assume the
                    defense of any Claim (with counsel reasonably satisfactory
                    to the Indemnified Party and with the Indemnified Party
                    having the right (at its expense) to join in any such action
                    or proceeding). The Indemnifying Party shall not consent to
                    a settlement or entry of any judgment, award or order that
                    (1) could affect the intellectual property rights or other
                    business interests of the Indemnified Party or (2) does not
                    include an unconditional release (including release under
                    California Civil Code Section 1542 or other law).
                  </span>
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    K. Termination. This is a non-cancelable sponsorship
                    contract.
                  </span>{" "}
                  <br />
                  <br />
                  <span>
                    L. Make Goods. AMP, in its sole and absolute discretion,
                    retains the right to provide other Sponsorship Elements in
                    the event that the Elements listed in the Main Agreement
                    cannot be satisfied or any reason.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    M. Confidentiality. Except as otherwise required by law or
                    the regulations of any securities exchange, the Parties
                    agree not to disclose “Confidential Information” (as
                    hereinafter defined) to any third party other than to their
                    respective directors, officers, employees, partners and
                    agents (and directors, officers, employees, partners and
                    agents of their respective Affiliates) and advisors
                    (including legal, financial and accounting advisors)
                    (collectively, “Representatives”), as needed. “Confidential
                    Information” shall include all non-public, confidential or
                    proprietary information that either party or its
                    Representatives make available to the other or either in
                    connection with this Agreement, including, but not be
                    limited to, the specific terms and conditions of this
                    Agreement as well as information related to the past,
                    present and future plans, ideas, business, strategies, sales
                    figures or projections, marketing programs and other
                    non-public information relating to either party. The
                    provisions of this Paragraph M will survive the expiration
                    or sooner termination of this Agreement for a period of
                    three (3) years.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    N. Right of Preemption. AMP, at its sole and absolute
                    discretion, retains the right to accept or reject any
                    programming and/or commercial messages, to preempt all or a
                    portion of any programming and/or commercial messages,
                    and/or to cancel all or a portion of this agreement
                    immediately, with or without advance notification. In the
                    event of such preemption or cancellation, AMP will attempt
                    but cannot guarantee, to provide advance notification.
                    Sponsor will not be charged for preempted portions of
                    programming and/or commercial messages, nor will Sponsor be
                    charged for cancelled portions of this agreement. Sponsor
                    agrees and is required to pay for that portion of
                    programming and/or commercial messages that is neither
                    preempted nor cancelled.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    O. Venue, Choice of Law, Attorney’s Fees. In actions related
                    to this Agreement each Party, on behalf of its successors
                    and assigns consent and submit to the exclusive jurisdiction
                    of the state and federal courts located in Orange County,
                    California and waive any objection to the propriety or
                    convenience of venue in such courts. This Agreement shall be
                    governed by and construed in accordance with the laws of the
                    State of California, without regard to its conflict of laws
                    principles. The prevailing party in such litigation shall be
                    reimbursed by the other party for all costs and expenses
                    issued in connection with the suit or action, including
                    without limitation reasonable attorney's fees at the trial
                    level and on appeal.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    P. Production. If Sponsor is providing the commercial
                    content and the production thereof, it must be delivered to
                    AMP no less than seven business days prior to the
                    commencement date of this Agreement. If Sponsor is providing
                    copy for AMP production, it must be delivered to AMP no less
                    than ten business days prior to the commencement date of
                    this Agreement. If AMP is writing and/or producing the
                    Sponsorship, Sponsor must deliver all requested and/or
                    required information no less than fifteen business days
                    prior to the commencement date of this Agreement. Failure to
                    deliver Sponsor approved Sponsorship Elements within this
                    time period shall not waive liability hereunder.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    Q. Failure to Perform. Upon acceptance of this Agreement AMP
                    will reserve all applicable elements identified above. Any
                    non-use of any reserved element will not waive any of
                    Sponsor’s liability
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    R. Miscellaneous.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    1. Neither party may assign or transfer this Agreement or
                    any interest herein (including, but not limited to, rights
                    and duties of performance), nor shall the same be assignable
                    by operation of law, without the prior written consent of
                    the other party. Neither party may assign or transfer this
                    Agreement (or a portion thereof) to a third party without
                    prior consent of the other.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    2. Each party hereto represents that: (i) the execution,
                    delivery and performance of this Agreement has been duly and
                    validly authorized by all necessary corporate or partnership
                    action, as applicable; (ii) this Agreement constitutes the
                    legally valid and binding obligation of such party; and
                    (iii) the execution, delivery and performance of this
                    Agreement will not violate or constitute a breach or default
                    under any other agreement by which it is bound. Each of the
                    parties hereto acknowledges and agrees that, except as
                    expressly set forth herein, neither party has made, and
                    neither party is relying on, any representation or warranty,
                    express or implied, with respect to the subject matter
                    hereof. The representations and warranties contained herein
                    shall survive the execution and delivery of this Agreement.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    3. This Agreement shall be subject to, and the parties
                    hereto agree to comply with, all applicable federal, state,
                    municipal and local laws and regulations now or hereafter in
                    effect.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    4. The performance by either party hereto of its respective
                    non-monetary obligations under this Agreement shall be
                    excused during the period of time that such performance is
                    delayed or prevented in whole or in part by acts of God,
                    fire, floods, storms, explosions, accidents, epidemics, war,
                    civil disorder, strikes or other labor difficulties, or any
                    law, rule, regulation, order or other action adopted or
                    taken by any federal, state or local government authority,
                    or any other cause not reasonably within such party’s
                    control, whether or not specifically mentioned herein.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    5. Neither the failure to insist upon strict performance of
                    any of the agreements, terms, covenants or conditions
                    hereof, nor the acceptance of monies due hereunder with
                    knowledge of a breach of this Agreement, shall be deemed a
                    waiver of any rights or remedies that either party hereto
                    may have or a waiver of any subsequent breach or default in
                    any of such agreements, terms, covenants or conditions. No
                    delay or omission in the exercise of any right, power or
                    remedy accruing to any party under this Agreement shall
                    impair any such right, power or remedy, nor shall it be
                    construed as a waiver of any future exercise of any right,
                    power or remedy.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    6. The provisions contained herein constitute the entire
                    agreement between the parties with respect to the subject
                    matter, and no statement or inducement with respect to the
                    subject matter hereof by either party hereto or by any agent
                    or representative of either party hereto which is not
                    contained in this Agreement shall be valid or binding among
                    the parties. The parties hereto are independent contractors,
                    and nothing in this Agreement shall be deemed or construed
                    to create, or have been intended to create, a partnership,
                    joint venture, employment or agency relationship between the
                    parties hereto. Each party hereto shall execute any and all
                    further documents or instruments and take all necessary
                    action that either party hereto may deem reasonably
                    necessary to carry out the proper purposes of this
                    Agreement.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    8. This Agreement has been fully reviewed and negotiated by
                    the parties hereto and their respective legal counsel.
                    Accordingly, in interpreting this Agreement, no weight shall
                    be placed upon which party hereto or its counsel drafted the
                    provision being interpreted. Wherever this Agreement
                    provides for one party hereto to provide approval or
                    consent, such approval or consent shall, except as may
                    otherwise be specified herein, be given in such party’s sole
                    judgment and discretion.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    9. If any term or provision of this Agreement shall be found
                    to be void or contrary to law or unenforceable, such term or
                    provision shall, but only to the extent necessary to bring
                    this Agreement within the requirements of law, be deemed to
                    be severable from the other terms and provisions hereof, and
                    the remainder of this Agreement shall be given effect as if
                    the parties had not included the severed term herein.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    10. All arrearages in the payment of any sums due to either
                    party hereto under the provisions of this Agreement shall
                    bear interest from the date due until paid at the greater of
                    (i) one percent (1%) per month and (ii) the highest rate of
                    interest then allowable pursuant to applicable law.
                  </span>{" "}
                  <br />
                  <br />
                  <span>
                    11. Each party to this Agreement represents that it is a
                    sophisticated commercial party capable of understanding all
                    of the terms of this Agreement, that it has had an
                    opportunity to review this Agreement with its counsel, and
                    that it enters this Agreement with full knowledge of the
                    terms of this Agreement.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    12. Unless otherwise set forth in the Main Agreement,
                    Sponsor shall be responsible for all costs with respect to
                    any Sponsorship purchased by Sponsor.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    13.Those provisions which by their nature are intended to
                    survive the expiration, cancellation or termination of this
                    Agreement, including, by way of example only, the
                    Indemnification and Confidentiality provisions, shall
                    survive the expiration, or termination of this Agreement.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    14.Section headings contained in this Agreement are for
                    reference purposes only and shall not be used to construe or
                    interpret this Agreement. Sponsor shall be obligated to pay
                    AMP a fee no less than Twenty Five U.S. Dollars ($25.00) for
                    each Sponsor check returned to AMP as un-payable (the
                    “Returned Check Fee”).
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    15. Any invoice, notice, or communication required or
                    permitted hereunder shall be in writing and deemed given if:
                    (i) delivered personally to an officer of the party to be
                    notified; (ii) sent by facsimile transmission to the
                    facsimile number below; or (iii) sent by overnight courier
                    or United States certified mail, postage prepaid, return
                    receipt requested, to the address set forth below, or other
                    addresses or facsimile numbers listed in Paragraph 2 of the
                    Agreement.
                  </span>{" "}
                  <br />
                  <br />
                  <span style={{ fontFamily: "Roboto" }}>
                    16. Sponsor shall, at their sole cost, maintain occurrence
                    based Commercial General Liability Insurance Policy,
                    including but not limited to contractual liability, personal
                    injury liability, Sponsorship injury liability and
                    products/completed operations liability coverage with
                    minimum limits of $1,000,000 per occurrence, Errors &
                    Omissions Liability/ Miscellaneous Professional Liability
                    Insurance, with a minimum limit of $2,000,000 per Claim and
                    Umbrella Liability Insurance with excess coverage of
                    $2,000,000 for each occurrence and $2,000,000 general
                    aggregate. Sponsor shall provide proof of insurance and
                    endorsements
                  </span>{" "}
                  <div
                    className="io-footer-text"
                    style={{
                      marginTop: "0.8rem",
                      color: "var(--Colors-Primary-500, #d2042d)",
                    }}
                  >
                    Advertising Marketplace, LLC
                  </div>
                  <span className="io-footer-text">All Rights Reserved</span>
                  <Divider className="io-divider-css"></Divider>
                </Col>
              )}
            </>
          );
        })}

        <Col>
          <p className="io-sponser-text-css">
            AMP – Insertion Order -{" "}
            <a
              href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="styling-hover-link"
            >
              Standard Terms
            </a>{" "}
            and Conditions
          </p>
          <span style={{ fontFamily: "Roboto" }}>
            1. Media Placement: (a) Advertising Marketplace, LLC (“Agency”) is
            authorized to act as agent for its Buyer (“Buyer”) in dealing with
            media vendor (“Seller”) or vendors (“Sellers”) and other applicable
            parties and is authorized to enter into contracts and schedules for
            placement of media on behalf of Buyer for Sellers products and/or
            services. Unless otherwise agreed, all placements will be made in
            Buyer’s name and Agency represents it has the authority to act and
            is acting on behalf of its Buyer as an “agent for a disclosed
            principal”. (b) If media product included in this contract is no
            longer available for any reason, the Seller will offer a product or
            service of equal or better advertising value to be approved by Buyer
            and Agency. In the event that Buyer approves the new product, the
            term of this contract will be extended after the expiration date of
            this contract for a period that is equal to the time in which
            Buyer’s advertisement was not on display or delivered. If Buyer or
            Agency do not approve the new product, Agency, on behalf of its
            Buyer, reserves the right to, in its sole decision, cancel this
            contract in its entirety and or the portion of the contract Seller
            or Sellers are not able to deliver. Upon cancellation, the Seller
            will be responsible for reimbursing Agency or Buyer a sum equal to:
            (i) the pro-rata media cost paid by Agency/Buyer for the period of
            time in which Buyer’s advertisement was not on display; and (ii) the
            out of pocket costs incurred by Agency/Buyer prior to the date of
            termination for production and delivery of the advertising material,
            art or copy hereunder which was not delivered. (c) If Sellers
            product includes illumination of any type and illumination is
            suspended for any reason during the term of the contract,
            Agency/Buyer is entitled to a pro-rata credit equal to 25% of the
            daily value of the contracted time period during which illumination
            is suspended. If illumination is suspended in excess of three (3)
            days, Agency/Buyer shall have the right to terminate the contract
            and Seller or Sellers shall be obligated to reimburse Agency/Buyer a
            sum equal to the out of pocket costs incurred by Agency/Buyer prior
            to the date of termination for production and delivery of the
            advertising material. (d)All media must be posted within two (2)
            business days of the contracted start date pending receipt of
            materials by established deadline.
          </span>
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            2. Representations and Warranties: (a) Seller represents and
            warrants that (i) it has the full power and authority to enter into
            this contract and to perform the obligations contained in this
            agreement; and that (ii) it has conducted proper due diligence
            ensuring that necessary permission and/or permits for advertising
            messages are valid; (iii) that all advertiser messages are
            acceptable based on any permits/permissions required through the
            contract duration; and (iv) it will perform the services using
            professional care and skill. (b) Agency represents and warrants that
            (i) it has full power and authority to enter into this contract and
            (ii) Buyer has the necessary licenses and clearances to use the
            content contained in the advertising materials.
          </span>{" "}
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            3. Financial Terms: Buyer is solely liable for all such media
            billings placed and properly run on its behalf. Agency will have no
            financial liability for the media placed with Seller, except to the
            extent Agency has received payment from Buyer designated for Seller.
            Upon receipt of such funds, Agency will assume sole liability.
            Payment terms are net sixty (60) days unless otherwise agreed in
            writing but the parties. Except as otherwise provided in this
            contract, Agency is not responsible for payment of any taxes, late
            payment fees, or additional charges incurred by Seller. Agency does
            not issue payment prior to receipt of appropriate proof of
            performance including signed affidavits of performance, photos of
            executed media and all other applicable items.{" "}
          </span>
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            4. Confidentiality: Each party agrees to take reasonable precautions
            to protect from disclosure the confidential information that it
            receives from the other party. "Confidential information" includes
            Buyer information disclosed by Agency and any information that is
            disclosed in a manner that would reasonably suggest that the
            information is confidential, but does not include any information
            that: (i) is, or later rightfully becomes, available to the public;
            (ii) was in the recipient's rightful possession prior to receipt of
            the information from the discloser; (iii) is later disclosed to the
            recipient by a third party who, to the best of receiving party’s
            knowledge, has no obligation of confidentiality; (iv) is
            independently developed by the recipient without the use or benefit
            of the confidential information; or (v) is required to be disclosed
            under court order or other legal process.
          </span>{" "}
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            5. Cancellation: (a) Agency reserves the right to cancel all media
            up until fourteen (14) days prior to the commencement date of the
            contracted product(s). Once the contract is in effect, Agency
            reserves the right to cancel the remainder of the contract starting
            sixty (60) days from the date of notice without penalty or short
            rate. (b) Agency requires sixty (60) day notice of renewal from all
            Sellers. If this notice is not given by the Seller in writing and
            accepted by Agency in writing, the contracted media will expire on
            the final day of the contract. The terms herein supersede any
            automatic media renewal provisions that may be contained in any
            other documents executed between the parties.
          </span>{" "}
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            {" "}
            6. Responsibility: Buyer agrees that it will be solely responsible
            for the content of any and all advertising placed on its behalf by
            Agency, including but not limited to, ensuring that all
            advertisements supplied are not misleading, inaccurate, indecent,
            libelous or unlawful and that their placement or publication will
            not violate the rights of any third party. Seller agrees to
            facilitate copy approval with appropriate entities such as owner,
            landlord or any other authority necessary prior to posting date on
            behalf of Agency/Buyer.
          </span>{" "}
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            7. Indemnification: Seller and Buyer will indemnify, defend and hold
            the other party and Agency harmless from any and all claims, suits,
            actions, liabilities, expenses and costs relating to losses, claims,
            damages, liabilities, judgments, settlements or costs and expenses
            (including reasonable attorneys' fees) against the other party and
            Agency, their employees, directors or affiliates, arising out of or
            in connection with a breach of this contract (including its
            representations under Section 2(a) or its gross negligence or
            willful misconduct under this contract.
          </span>{" "}
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            8. Force Majeure: Each party will be excused from performing
            obligations contained in this contract while such performance is
            prevented by an act of God, fire, flood, earthquake, transportation
            disruption, war, insurrection, labor dispute, or any other
            occurrence beyond the reasonable control of that party. If such
            Force Majeure event continues for a period of thirty (30) days or
            longer, Agency and or Buyer shall have the right to terminate this
            contract and Seller will reimburse Agency an or Buyer for the period
            of time in which Buyer’s advertisement is not on display.
          </span>{" "}
          <br />
          <br />
          <span style={{ fontFamily: "Roboto" }}>
            9. General: (a) This contract contains the entire agreement between
            the parties relating to the advertising services and supersedes any
            previous agreements or understanding whether written or oral. No
            amendment, modification or waiver shall be made to this contract
            unless made in writing and signed by both parties. (b) If any
            provision of this contract is held to be invalid, illegal or
            unenforceable, the remaining provisions of the contract will remain
            in full force and effect. (c) This contract is also subject to the
            User Agreement and all Policies that the parties agreed to when
            registering with Agency. If there is a conflict between the User
            Agreement, Agencies Policies as outlined on Agencies website
            (www.advertisingmarketplace.com) and these{" "}
            <a
              href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="styling-hover-link"
              style={{ color: "#007bff" }}
            >
              Standard Terms{" "}
            </a>
            and Conditions, these{" "}
            <a
              href={`${PDF_BASE_URL}/AMPPrivacyNotice.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="styling-hover-link"
              style={{ color: "#007bff" }}
            >
              Standard Terms
            </a>{" "}
            and Conditions shall prevail.
          </span>
          <div
            className="io-footer-text"
            style={{
              marginTop: "0.8rem",
              color: "var(--Colors-Primary-500, #d2042d)",
            }}
          >
            Advertising Marketplace, LLC
          </div>
          <span className="io-footer-text">All Rights Reserved</span>
        </Col>
        <Col className="io-footer-bottom-css">
          <div className="common-css">
            <span className="view-io-terms">
              Need assistance? Contact support at{" "}
              <a
                style={{ color: "#D2042D" }}
                href="mailto:support@advertisingmarketplace.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@advertisingmarketplace.com
              </a>
            </span>
          </div>
        </Col>
        <div className="tag-line">
          We make advertising easy<sup className="superscript">SM</sup>
        </div>
      </div>
      {/* )} */}
      <Modal
        open={isHoldRequestModalOpen}
        centered
        onCancel={() => setIsHoldRequestModalOpen(false)}
        destroyOnClose
        footer={false}
        className="product-request-hold-modal"
      >
        <ProductRequestHoldModal
          selectedProduct={selectedProduct}
          campaignDetails={campaignDetails}
          productActionType={productActionType}
          onClose={() => {
            setIsHoldRequestModalOpen(false);
          }}
        />
      </Modal>

      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};
export default CampaignDetailsIO;
